import React, { useCallback } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { useRecoilState, useRecoilValue } from 'recoil';

import { hourlyWeatherPageTestIDs, Theme } from '@constants';
import { useMyWeatherHourlyForecast } from '@hooks';
import { hourlyForecastState, hourlyWeatherPageFocusIndex } from '@store';

import { HourlyHourForecastTile, TILE_WIDTH } from './HourlyHourForecastTile';

import arrowLeft from '../../../assets/icons/editIcons/arrow_left.png';
import arrowRight from '../../../assets/icons/editIcons/arrow_right.png';
import { getForecastWeatherPhrase } from '../../../helpers/getWeatherPhrase';
import { FocusableFlatList } from '../../focusable/FocusableFlatList/FocusableFlatList';

export const UpcomingHourlyForecast = ({ nextFocusUp }) => {
  const { params } = useRoute();
  const forecasts = useMyWeatherHourlyForecast(params?.validTimeUtc);
  const { error } = useRecoilValue(hourlyForecastState);
  const [focusIndex, setFocusIndex] = useRecoilState(hourlyWeatherPageFocusIndex);

  const initialIndex = 0;

  const _getItemLayout = useCallback(
    (_, index) => ({
      length: Theme.px(TILE_WIDTH),
      offset: Theme.px(TILE_WIDTH * index),
      index,
    }),
    [],
  );

  // TODO fix this lint warning
  // eslint-disable-next-line react/no-unstable-nested-components
  const _renderItem = ({ dayOfWeek, iconCodeExtend, precipChance, temperature, validTimeUtc }, index) => (
    <HourlyHourForecastTile
      dayOfWeek={dayOfWeek}
      error={error}
      iconCodeExtend={iconCodeExtend}
      precipChance={precipChance}
      temperature={temperature}
      testID={`${hourlyWeatherPageTestIDs.hourTile}_${index + 1}`}
      validTimeUtc={validTimeUtc}
      weatherPhrase={getForecastWeatherPhrase({ iconCodeExtend })}
      onPress={() => console.log(`Hourly tile ${index} selected`)}
    />
  );

  return (
    <View>
      <Image
        source={arrowLeft}
        style={[styles.arrowLeft, focusIndex === 0 ? styles.arrowDisabled : styles.arrowEnabled]}
      />
      <Image
        source={arrowRight}
        style={[styles.arrowRight, focusIndex === forecasts.length - 1 ? styles.arrowDisabled : styles.arrowEnabled]}
      />
      <View style={styles.tileWrapper}>
        <FocusableFlatList
          data={forecasts}
          focusIndexChanged={setFocusIndex}
          focusPositions={6}
          getItemLayout={_getItemLayout}
          horizontal
          initialNumToRender={6}
          initialScrollIndex={initialIndex}
          itemUnderlayColor={'clear'}
          keyExtractor={(_, index) => `${index}-hourlyForecastTile`}
          nextFocusDown={null}
          nextFocusLeft={null}
          nextFocusRight={null}
          nextFocusUp={nextFocusUp}
          renderItem={_renderItem}
          showsHorizontalScrollIndicator={false}
          testID={hourlyWeatherPageTestIDs.hourlyWeatherTilesList}
          wrapItem={false}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  arrowDisabled: {
    tintColor: Theme.disabledColor,
  },
  arrowEnabled: {
    tintColor: Theme.enabledColor,
  },
  arrowLeft: {
    height: Theme.px(38),
    left: Theme.px(65),
    position: 'absolute',
    top: Theme.px(170),
    width: Theme.px(23),
  },
  arrowRight: {
    height: Theme.px(38),
    position: 'absolute',
    right: Theme.px(82),
    top: Theme.px(170),
    width: Theme.px(23),
  },
  tileWrapper: {
    flexDirection: 'row',
    height: Theme.px(400),
    marginLeft: Theme.px(120),
    width: Theme.px(TILE_WIDTH * 6 + 6),
  },
});
